// @/components/DashboardLoader/DashboardLoader.tsx
import "./DashboardLoader.scss";
import type { LoadEvent } from "./useDashboardLoader";

interface Props {
  visible: boolean;
  events: LoadEvent[];
}

export default function DashboardLoader({ visible, events }: Props) {
  if (!visible) return null;

  return (
    <div className="dashboard-loader-overlay">
      <div className="dashboard-loader-modal">
        <div className="loader-title">
          Loading Dashboard…
        </div>

        <ul className="loader-events">
          {events.map((e) => (
            <li key={e.id} className={e.done ? "done" : ""}>
              <span className="check">
                {e.done ? "✔" : "•"}
              </span>
              {e.label}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}